<template>
  <div
    class="bg-white col-span-12 md:col-span-3 min-h-64 rounded-xl border mx-3 md:mx-0 border-neutral-200 shadow-[0_10px_50px_rgba(0,0,0,0.1)] flex flex-col gap-3 items-center justify-center p-6"
  >
    <img
      class="w-32 h-32 object-cover rounded-full"
      :src="profileImageUrl"
      alt="Profile"
    />

    <h3 class="text-lg text-center font-semibold text-gray-800">
      {{ $store.state.userLogged }}
    </h3>
    <span
      :class="[
        'inline-block px-3 py-1 text-sm font-medium rounded-full',
        $store.state.userMembershipStatus === 'Active'
          ? 'text-green-700 bg-green-100'
          : 'text-red-700 bg-red-100',
      ]"
    >
      {{ $store.state.userMembershipStatus }}
    </span>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  setup() {
    const profileImageUrl = computed(() => {
      return localStorage.getItem("patientProfile");
    });

    return {
      profileImageUrl,
    };
  },
};
</script>
